import { render } from "./detalleNegocio.vue?vue&type=template&id=223e4992&scoped=true"
import script from "./detalleNegocio.vue?vue&type=script&lang=js"
export * from "./detalleNegocio.vue?vue&type=script&lang=js"

import "./detalleNegocio.vue?vue&type=style&index=0&id=223e4992&lang=scss&scoped=true"

import exportComponent from "C:\\xampp-80\\htdocs\\v2crmred\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-223e4992"]])

export default __exports__